// export const APP_API_URL='http://192.168.1.140:8082';
export const APP_API_URL='https://api.vieunite.com';
export const Primary_Font = {
    fontFamily: "Proxima Nova bold, sans-serif",
}

export const TitleFont = {
    fontSize: '42px',
    fontFamily: "Proxima Nova bold, sans-serif",
}